import { User } from '@/api/model/user'
import { BaseModel } from '@/api/base-model'
import { ActionAPI } from '@/api/backend-client'
import { Referral } from '@/api/model/referral'
import { ActionType, ActionAppointmentType } from '@/api/types'

export class Action extends BaseModel<Action> {
    protected collectionName = ActionAPI.collectionName

    constructor(
        public referral: Referral|null,
        public id: string,
        public type: ActionType,
        public appointmentType: ActionAppointmentType,
        public actionDate: Date,
        public assignedTo: User[],
        public comment: string,
        public completed: boolean,
        public createdBy: User|null,
        public createdAt: Date,
        public updatedAt: Date,
        public source: string = null,
        public medewerker: string = null,
        public realworksStatus: string = null,
    ) { super(id) }

    static get availableTypes(): string[] {
        return [
            ActionType.MEETING,
            ActionType.EMAIL,
            ActionType.CALL,
            ActionType.REMINDER,
            ActionType.LETTER,
            ActionType.BILLING,
            ActionType.UPDATE,
            ActionType.NOTIFICATION,
            ActionType.ADD_TO_PIPELINE,
        ]
    }

    static get availableAppointmentTypes(): string[] {
        return [
            ActionAppointmentType.VIDEO,
            ActionAppointmentType.PHONE,
            ActionAppointmentType.OFFICE,
            ActionAppointmentType.CUSTOMER,
        ]
    }

    static fromData(data: any): Action {
        if (data === null || typeof data === 'string' || data instanceof Action) {
            return data
        }

        return new Action(
            data.referral ? Referral.fromData(data.referral) : null,
            data.id,
            data.type,
            data.appointmentType,
            data.actionDate,
            Object.values(data.assignedTo || {}).map(entry => User.fromData(entry)),
            data.comment,
            data.completed,
            data.createdBy ? User.fromData(data.createdBy) : null,
            data.createdAt,
            data.updatedAt,
            data.source ? data.source : null,
            data.medewerker,
            data.realworksStatus,
        )
    }
}
